import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const LocationIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M5.5 4.5L4 8L3.5 10L4.5 12.5L7 17L10.5 21.5L12.5 22.5L14.5 20.5L17.5 16.5L20 12V8.5L18.5 4L14.5 1.5H11L7.5 2.5L5.5 4.5Z"
        fill={getColor(secondaryColor)}
      />
      <circle cx="12" cy="9" r="3" fill="#FBFBF8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.05001C7.83025 2.05001 4.45 5.43026 4.45 9.60001C4.45 10.564 4.84177 11.8091 5.52814 13.1957C6.20514 14.5633 7.12711 15.9865 8.092 17.282C9.05617 18.5765 10.0483 19.7236 10.8539 20.5396C11.2584 20.9493 11.6029 21.2622 11.864 21.4662C11.915 21.506 11.9603 21.5397 12 21.5679C12.0397 21.5397 12.085 21.506 12.136 21.4662C12.3971 21.2622 12.7416 20.9493 13.1461 20.5396C13.9517 19.7236 14.9438 18.5765 15.908 17.282C16.8729 15.9865 17.7949 14.5633 18.4719 13.1957C19.1582 11.8091 19.55 10.564 19.55 9.60001C19.55 5.43026 16.1697 2.05001 12 2.05001ZM11.814 21.6822C11.8141 21.6819 11.8185 21.6797 11.8269 21.6767C11.818 21.681 11.8139 21.6825 11.814 21.6822ZM12.1731 21.6767C12.1815 21.6797 12.1859 21.6819 12.186 21.6822C12.1862 21.6825 12.182 21.681 12.1731 21.6767ZM2.75 9.60001C2.75 4.49137 6.89137 0.350006 12 0.350006C17.1086 0.350006 21.25 4.49137 21.25 9.60001C21.25 10.9556 20.7217 12.4828 19.9954 13.9499C19.2598 15.4359 18.2766 16.9478 17.2714 18.2974C16.2655 19.648 15.2226 20.8561 14.3558 21.734C13.9241 22.1712 13.5229 22.5399 13.1826 22.8058C13.0137 22.9378 12.8427 23.0579 12.6782 23.1492C12.546 23.2226 12.2946 23.35 12 23.35C11.7054 23.35 11.454 23.2226 11.3218 23.1492C11.1573 23.0579 10.9863 22.9378 10.8174 22.8058C10.4771 22.5399 10.0759 22.1712 9.64423 21.734C8.77744 20.8561 7.73454 19.648 6.72861 18.2974C5.7234 16.9478 4.74021 15.4359 4.00459 13.9499C3.27833 12.4828 2.75 10.9556 2.75 9.60001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0004 6.7C10.813 6.7 9.85039 7.66259 9.85039 8.85C9.85039 10.0374 10.813 11 12.0004 11C13.1878 11 14.1504 10.0374 14.1504 8.85C14.1504 7.66259 13.1878 6.7 12.0004 6.7ZM8.15039 8.85C8.15039 6.7237 9.87409 5 12.0004 5C14.1267 5 15.8504 6.7237 15.8504 8.85C15.8504 10.9763 14.1267 12.7 12.0004 12.7C9.87409 12.7 8.15039 10.9763 8.15039 8.85Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LocationIconFilled;
